import { Component, Input, OnInit } from "@angular/core";
import "./dashboardBoxSmall.component.scss";

@Component({
    selector: "dashboard-box-small",
    template: require("./dashboardBoxSmall.component.html")
})
export class DashboardBoxSmallComponent {
    @Input() boxIcon: string;
    @Input() boxIconClass: string;
    @Input() boxTitle: string;
    @Input() boxSubtitle: string;
    @Input() color: string;

    // ---

    constructor() {
        //console.log('boxIcon', this.boxIcon);
        //console.log('boxIconClass', this.boxIconClass);
        //console.log('boxTitle', this.boxTitle);
        //console.log('boxSubtitle', this.boxSubtitle);
    }
}
